<template>
  <div>
    <div class="flex-col group_11">
      <img
        class="shrink-0 self-start image_2 image_3"
        style="height: 51px;"
        :src="$images.platBg"
      />
      <div class="flex-row self-stretch relative section_10">
        <div class="flex-row items-center row-box">
          <div class="row">
            <span class="key">证书编号</span>
            <div class="section_11">
              <el-input class="select" placeholder="请输入证书编号" v-model="form.zsbh" />
            </div>
          </div>
          <div class="row">
            <span class="key">发证机构名称</span>
            <div class="section_11">
              <el-input class="select" placeholder="请输入发证机构名称" v-model="form.jgmc" />
            </div>
          </div>
          <div class="row">
            <span class="key">创新项目名称</span>
            <div class="section_11">
              <el-input class="select" placeholder="请输入创新项目名称" v-model="form.xmmc" />
            </div>
          </div>
          <div class="row">
            <span class="key">获证企业名称</span>
            <div class="section_11">
              <el-input class="select" placeholder="请输入获证企业名称" v-model="form.qymc" />
              <!--<el-select-->
                <!--v-model="company"-->
                <!--class="select"-->
                <!--placeholder="请选择"-->
              <!--&gt;-->
                <!--<el-option-->
                  <!--v-for="item in companyOptions"-->
                  <!--:key="item.value"-->
                  <!--:label="item.label"-->
                  <!--:value="item.value">-->
                <!--</el-option>-->
              <!--</el-select>-->
            </div>
          </div>
          <div class="row">
            <span class="key">认证对象</span>
            <div class="section_11">
              <el-input class="select" placeholder="请输入认证对象" v-model="form.rzdx" />
            </div>
          </div>
        </div>
        <div class="flex-col justify-start items-center text-wrapper_2 ml-656" @click="search">
          <span class="font_8 text_19">搜索</span>
        </div>
      </div>
      <div class="flex-col self-stretch relative group_12">
        <!-- <p class="select-box">
          <span class="word">隐藏已停用的规格型号</span><el-switch class="switch" v-model="isOpen" />
        </p> -->
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="num"
            label="序号"
            width="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="zsbh"
            width="190"
            label="证书编号">
            <template slot-scope="scope">
              <p class="row">
                <span class="name">{{scope.row.zsbh.name}}</span>
                <span
                  class="status"
                  :class="{
                    fail: scope.row.zsbh.type === 0
                  }"
                >{{getStatusName(scope.row.zsbh.type)}}</span>
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="jgmc"
            label="发证机构名称">
          </el-table-column>
          <el-table-column
            prop="xmmc"
            label="创新项目名称">
          </el-table-column>
          <el-table-column
            prop="qymc"
            label="获证企业名称">
          </el-table-column>
          <el-table-column
            prop="rzdx"
            label="认证对象">
          </el-table-column>
          <el-table-column
            prop="name5"
            label="证书/报告">
            <template slot-scope="scope">
              <el-button class="btn" @click="handleDetail(scope.row)" type="text" size="small">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <p class="word">
          <!-- *灰色代表此条目中的规格型号在其应用的项目中已停止使用 -->
          </p>
        <div class="page-box">
          <el-pagination
            background
            prev-text="上一页"
            next-text="下一页"
            layout="prev, pager, next"
            :current-page="page"
            :page-size="limit"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
      isOpen: false, // 隐藏已停用的规格型号
      page: 1,
      limit: 10,
      total: 0,
      tableData: [
        // { order: '07', no: { name: 'xxxx', type: 0 }, name: 'xxxx' },
        // { order: '07', no: { name: 'xxxx', type: 1 }, name: 'xxxx' }
      ],
      // company: 1,
      // companyOptions: [
      //   { label: '所有', value: 1 }
      // ],
      form: {
        zsbh: '',
        jgmc: '',
        xmmc: '',
        qymc: '',
        rzdx: ''
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.search()
    },
    async getList () {
      const res = await this.$https.getZsbgsqList({
        ...this.form, page: this.page, limit: this.limit
      })
      this.total = res.data.data.count
      this.tableData = res.data.data.list.map(v => {
        return {
          ...v,
          zsbh: {
            name: v.zsbh,
            type: v.zsbh_state
          }
        }
      })
      console.log('retro==>', res)
    },
    handleCurrentChange (value) {
      this.page = value
      this.getList()
      console.log('handleCurrentChange==>', value)
    },
    search () {
      // this.$message.success('搜索')
      this.page = 1
      this.getList()
    },
    handleDetail (row) {
      console.log('handleDetail==>', row)
      this.$emit('onRow', row)
    },
    getStatusName (type) {
      const config = {
        2: '注销',
        1: '有效'
      }
      return config[type]
    }
  }
}
</script>

<style lang="less" scoped>
  .page-box{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .select-box{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;

    .word{
      font-family: PingFang;
      font-weight: 500;
      font-size: 12px;
      color: #333333;
      line-height: 15px;
      margin-right: 10px;
    }
  }
  .row-box{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 942px;

    .row{
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 17px;

      .key{
        width: 110px;
        color: white;
        text-align: right;
      }

      .section_11{
        margin-left: 7px;
      }
    }
  }
  .group_11 {
    .image_3 {
      margin-left: 118px;
      visibility: hidden;
    }
    .section_10 {
      margin-top: -39px;
      padding: 16px 22px 0px 0px;
      background-color: #006ed1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      .text_17 {
        color: #ffffff;
        line-height: 14px;
      }
      .section_11 {
        background-color: #ffffff;
        height: 26px;

        .select{
          width: 197px;
        }

        /deep/ .el-input__inner{
          height: 26px;
          line-height: 26px;
          border-radius: 0px;
        }

        /deep/ .el-input__icon{
          line-height: 26px;
        }

        .text_18 {
          color: #666666;
        }
        .image_4 {
          width: 8px;
          height: 5px;
        }
      }
      .text-wrapper_2 {
        padding: 8px 0;
        background-color: #004290;
        width: 68px;
        height: 26px;
        cursor: pointer;
        .text_19 {
          color: #ffffff;
          line-height: 11px;
        }
      }
    }
    .group_12 {
      margin-top: 12px;
      padding-bottom: 47px;

      .btn{
        color: #0067d1;

        &:hover{
          opacity: .8;
        }
      }

      .row{
        display: flex;
        flex-direction: row;
        align-items: center;

        .name{
          font-family: PingFang;
          font-weight: 500;
          font-size: 12px;
          color: #333333;
          line-height: 18px;
        }
        .status{
          background: #19891E;
          font-weight: 800;
          font-size: 10px;
          color: #FFFFFF;
          line-height: 18px;
          text-align: center;
          padding: 0px 10px;
          margin-left: 10px;

          &.fail{
            background: #D60000;
          }
        }
      }

      .word{
        text-align: right;
        font-weight: normal;
        font-size: 10px;
        color: #666666;
        line-height: 18px;
      }

      /deep/ thead th{
        background: #E8F0FA;
        color: #323232;
      }
      /deep/ .el-table--border, .el-table--group {
        border: 1px solid #bebebe !important;
      }
      /deep/ .el-table--border  td,
      /deep/ .el-table--border th,
      /deep/ .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
        border-right: 1px solid #bebebe !important;
      }
      /deep/ .el-table--border th.el-table__cell {
        border-bottom: 1px solid #bebebe;
        color: #000000;
      }
      /deep/ .el-table  td, .el-table th.is-leaf  {
        border-bottom: 1px solid #bebebe!important;
      }
      .section_12 {
        padding: 14px 26px;
        background-color: #e8f0fa;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_21 {
          margin-right: 709px;
        }
      }
      .section_18 {
        margin-top: 279px;
        padding: 18px 33px;
        background-color: #ffffff;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_28 {
          margin-right: 662px;
        }
      }
      .section_13 {
        padding: 18px 35px;
        background-color: #ffffff;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_22 {
          margin-right: 660px;
        }
      }
      .pos_4 {
        position: absolute;
        left: 0;
        right: 0;
        top: 44px;
      }
      .font_9 {
        font-size: 12px;
        font-family: PingFang;
        line-height: 10px;
        color: #333333;
      }
      .section_14 {
        padding: 18px 34px;
        background-color: #f6f6f6;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_23 {
          margin-right: 661px;
          line-height: 11px;
        }
        .text_25 {
          margin-right: 649px;
        }
        .text_29 {
          line-height: 9px;
        }
        .text_30 {
          margin-right: 643px;
        }
      }
      .pos_5 {
        position: absolute;
        left: 0;
        right: 0;
        top: 91px;
      }
      .section_15 {
        padding: 16px 34px 19px;
        background-color: #ffffff;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_24 {
          margin-right: 643px;
        }
      }
      .pos_6 {
        position: absolute;
        left: 0;
        right: 0;
        top: 138px;
      }
      .pos_7 {
        position: absolute;
        left: 0;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .section_16 {
        padding: 19px 33px 16px;
        background-color: #ffffff;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_26 {
          margin-right: 674px;
        }
      }
      .pos_8 {
        position: absolute;
        left: 0;
        right: 0;
        top: 232px;
      }
      .section_17 {
        padding: 16px 34px 19px;
        background-color: #f6f6f6;
        border-left: solid 1px #bebebe;
        border-right: solid 1px #bebebe;
        border-top: solid 1px #bebebe;
        border-bottom: solid 1px #bebebe;
        .text_27 {
          margin-right: 661px;
        }
      }
      .pos_9 {
        position: absolute;
        left: 0;
        right: 0;
        top: 279px;
      }
      .pos_10 {
        position: absolute;
        left: 0;
        right: 0;
        top: 372px;
      }
      .image_5 {
        width: 2px;
        height: 421px;
      }
      .pos_3 {
        position: absolute;
        left: 86px;
        bottom: 0;
      }
    }
    .font_8 {
      font-size: 12px;
      font-family: PingFang;
      line-height: 12px;
      color: #333333;
    }
  }
</style>
